import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { StyledEventHeader } from './index.style';

const TRANS_COMPONENTS = { br: <br /> };

const EventHeader = ({ thresholdText }) => {
  const { t } = useTranslation();

  return (
    <StyledEventHeader>
      <Typography
        variant="body-20-medium"
        className="eyebrow"
        textTransform="uppercase"
      >
        {t('topPaidEventEyebrow')}
      </Typography>
      <Typography variant="heading-48-bold" component="h1" className="title">
        <Trans
          t={t}
          i18nKey="topPaidEventTitle"
          components={TRANS_COMPONENTS}
        />
      </Typography>
      <Typography variant="body-16-regular" className="description">
        <Trans
          t={t}
          i18nKey="topPaidEventDescription"
          values={{ threshold: thresholdText }}
          components={TRANS_COMPONENTS}
        />
      </Typography>
    </StyledEventHeader>
  );
};

export default EventHeader;
